import { DatosAspiranteModel } from './datos-aspirante.model';

export class ResidenciaFiscalExtranjeroModel {
  CodPais: string='';
  Direccion: string = '';
  IdentificacionTributaria: string = '';

  clear() {
    this.CodPais = '';
    this.Direccion = '';
    this.IdentificacionTributaria = '';
  }
}
